import React from "react";
import classNames from "classnames";
import { withNativeProps } from "../../utils/with-native-props";
var classPrefix = "tc-badge";
export var dot = /*#__PURE__*/React.createElement(React.Fragment, null);
export var Badge = function Badge(props) {
  var content = props.content,
    color = props.color,
    children = props.children,
    _props$zero = props.zero,
    zero = _props$zero === void 0 ? false : _props$zero;
  var isDot = content === dot;
  var badgeCls = classNames(classPrefix, !!children && "".concat(classPrefix, "-fixed"), isDot && "".concat(classPrefix, "-dot"), props.bordered && "".concat(classPrefix, "-bordered"), zero && content === "0" && "".concat(classPrefix, "-none"));
  var element = content || content === 0 ? withNativeProps(props, /*#__PURE__*/React.createElement("div", {
    className: badgeCls,
    style: {
      "--color": color
    }
  }, !isDot && /*#__PURE__*/React.createElement("div", {
    className: "".concat(classPrefix, "-content")
  }, content))) : null;
  return children ? /*#__PURE__*/React.createElement("div", {
    className: classNames("".concat(classPrefix, "-wrapper"), props.wrapperClassName),
    style: props.wrapperStyle
  }, children, element) : element;
};